import { GenericActivityListPagination, GenericActivityListSort } from 'src/models/genericActivityList';
import { AbstractQuery } from 'src/models/query';

export class GetTheCalendarModuleAppointmentsForTheUserQuery extends AbstractQuery {
	limit = 100;
	name = 'IFS_DesktopModule_Calendar_Query_Queries_GetTheCalendarModuleAppointmentsForTheUserQuery';
	page = 1;
	sort: Array<GenericActivityListSort> = [{ direction: 'DESC', property: 'timestamp' }];
	standardFilterSelection = '';

	constructor(
		view: 'all' | 'mine',
		searchTerm: string,
		hiddenSearchTerm: string,
		pagination: GenericActivityListPagination,
		sort: GenericActivityListSort
	) {
		super();

		this.page = pagination.page;
		this.limit = pagination.rowsPerPage;
		this.sort = [sort];

		this.standardFilterSelection =
			view === 'mine'
				? 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonMine'
				: 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonAll';

		this.parameters.push({
			DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton: this.standardFilterSelection,
		});
		this.parameters.push({ DesktopModuleToolbarButtonGlobalizationFilter: true });
		this.parameters.push({ DesktopModuleToolbarButtonArchivFilter: false });
		this.parameters.push({ DesktopModuleToolbarTextfieldSearchField: searchTerm });
		this.parameters.push({ DesktopModuleToolbarHiddenfieldSearchField: hiddenSearchTerm });
		this.parameters.push({
			DesktopModuleToolbarDatefieldDateFilter: 'DesktopModuleToolbarSegmentedButtonTimeRangeSelectionButtonAll',
		});

		this.disableSubscriptionsWhileSearchIsActive(searchTerm, hiddenSearchTerm);

		this.parameters.push({ DesktopModuleCustomFilterCondition: {} });
		this.parameters.push({
			DesktopModuleToolbarCycleButtonDirection: 'DesktopModuleToolbarCycleButtonDirectionBidirectional',
		});
		this.parameters.push({ DesktopModuleBoxIds: [] });
		this.parameters.push({ DesktopModuleToolbarSplitButtonUserFilter: [] });
	}

	uniqueQueryIdentifier(): string {
		return this.createStableIdentifier({
			standardFilterSelection: this.standardFilterSelection,
		});
	}
}
